import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export class CostDocumentOtherViewModel {
  @IsNumber()
  @Expose()
  documentTypeId!: number;
  @IsNumber()
  @Expose()
  formOfPaymentId!: number;
  @IsNumber()
  @IsOptional()
  @Expose()
  contractComponentId!: number;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @IsOptional()
  @Expose()
  description!: string | null;
  @IsString()
  @Expose()
  issuePlace!: string;
  @IsString()
  @Expose()
  issueDate!: string;
  @IsString()
  @Expose()
  saleDate!: string;
  @IsString()
  @Expose()
  receiptDate!: string;
  @IsString()
  @Expose()
  paymentDate!: string;
  @IsString()
  @Expose()
  exchangeDate!: string;
  @IsNumber()
  @Expose()
  exchangeRate!: number;
  @IsString()
  @Expose()
  currency!: string;
  @IsNumber()
  @Expose()
  amount!: number;
  @IsNumber()
  @Expose()
  status!: number;
  @IsBoolean()
  @Expose()
  canChangeStatus!: boolean;
  @IsBoolean()
  @Expose()
  isEditingLocked!: boolean;
  @IsBoolean()
  @Expose()
  hasPermissions!: boolean;
  @IsNumber()
  @IsOptional()
  @Expose()
  bankAccountId!: number | null;
  @IsNumber()
  @IsOptional()
  @Expose()
  creditCardId!: number | null;
  @IsOptional()
  @IsString()
  @Expose()
  ksefNumber!: string;
  @IsString()
  @IsOptional()
  @Expose()
  ksefAcquisitionDate!: string | null;
  @IsString()
  @IsOptional()
  @Expose()
  correctedDocumentNumber!: string | null;
}
